import Box from '@mui/material/Box'
import VerifyItem from 'components/DocumentDetail/Editor/Verify/VerifyItem'
import { useRootLoaderData } from 'components/Root.loader'
import { DOC_TYPE, FIELD_TYPE } from 'config'
import { Document } from 'entities/Documents'
import { DocumentOrderForm } from 'entities/DocumentsOrderForm'
import { useMemo } from 'react'
import { getHighlightsPattern } from 'utils/highlights'
import { omitKeys } from 'utils/utils'

interface Props {
  docDetail: Document
}

function VerifyEditor({ docDetail }: Props) {
  const { expenseTypesOptions: expTypeOptions } = useRootLoaderData()
  const { docInfo, verifyData } = docDetail
  const users = verifyData ? omitKeys(verifyData, 'verifyData') : {}
  const srcs = docDetail.getSrcs()
  const highlights = useMemo(() => docDetail.getHighlights(), [docDetail])
  const isInvoiceOrOrderForm =
    docInfo.documentType === DOC_TYPE.INVOICE || docInfo.documentType === DOC_TYPE.ORDER_FORM
  const labelDocument = isInvoiceOrOrderForm ? (docDetail as DocumentOrderForm) : null

  const getLabel = (field: string) => {
    if (!labelDocument) {
      return
    }
    const [category, fieldName] = field.split('.') as [string, string]
    return labelDocument.getLabel(category, fieldName)
  }

  return (
    <Box sx={{ overflowY: 'auto' }}>
      {verifyData?.verifyData.map((item) => {
        let type: 'text' | 'select' | 'checkbox' = 'text'
        let formKey: string
        let hlKey: string
        if (isInvoiceOrOrderForm && item.fieldName.match(/^itemLines/)) {
          const itemKey = item.fieldName.split('.').pop()
          formKey = `${item.id}.${itemKey}`
          hlKey = `${item.id}.${itemKey}\\.`
          if (itemKey === 'expenseTypeCode') type = 'select'
        } else {
          // title conflicts with reduxtStore.documentDetails.[docid].ocrResp
          if (item.fieldName === 'title') {
            formKey = hlKey = '_title'
          } else if (isInvoiceOrOrderForm) {
            formKey = `${item.fieldName}`
            hlKey = `${item.fieldName}\\.`
          } else {
            formKey = hlKey = item.fieldName
          }
        }
        if (item.user1Data.type === FIELD_TYPE.CHECKBOX) {
          type = 'checkbox'
        }
        const label = isInvoiceOrOrderForm ? getLabel(item.fieldName) : item.fieldName
        const fieldRegex = getHighlightsPattern(true, hlKey)
        const currentHighlights = highlights.filter(
          (x) => (hlKey === '_title' && x.name === 'title') || fieldRegex.test(x.name),
        )

        return (
          <VerifyItem
            users={users}
            key={formKey}
            label={label || ''}
            formKey={formKey}
            srcs={srcs}
            highlights={currentHighlights}
            isInvoiceOrOrderForm={isInvoiceOrOrderForm}
            item={item}
            type={type}
            options={expTypeOptions}
          />
        )
      })}
    </Box>
  )
}

export default VerifyEditor
